// djin-cloud/web/src/hooks/useEnergySummary.ts

import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export interface EnergySummaryPoint {
  date: string;
  consumption_kwh: number;
  generation_kwh: number;
  bess_throughput_kwh: number;
  peak_demand_kw: number;
  avg_load_kw: number;
}

export interface EnergySummaryKPIs {
  total_consumption_kwh: number;
  total_generation_kwh: number;
  peak_demand_kw: number;
  avg_load_kw: number;
  renewable_mix_pct: number;
}

export interface EnergySummaryResponse {
  summary: EnergySummaryKPIs;
  data: EnergySummaryPoint[];
}

export function useEnergySummary(
  siteId: string,
  period: 'daily' | 'weekly' | 'monthly',
  monthOrYear: string,
) {
  const params =
    period === 'monthly' ? { period, year: monthOrYear } : { period, month: monthOrYear };

  return useQuery({
    queryKey: ['energy-summary', siteId, period, monthOrYear],
    queryFn: () =>
      api
        .get<{ data: EnergySummaryResponse }>(`/v1/sites/${siteId}/energy-summary`, { params })
        .then((r) => r.data.data),
    staleTime: 5 * 60 * 1000,
    enabled: Boolean(siteId),
  });
}
